export default {
  // list
  'crm_customer_contact.column.customerId': 'customerId',
  'crm_customer_contact.column.contactName': 'contactName',
  'crm_customer_contact.column.contactPhone': 'contactPhone',
  'crm_customer_contact.column.contactType': 'contactType',
  'crm_customer_contact.column.primaryFlag': 'primaryFlag',
  'crm_customer_contact.column.enableFlag': 'enableFlag',
  'crm_customer_contact.column.createBy': 'createBy',
  'crm_customer_contact.column.updateBy': 'updateBy',
  'crm_customer_contact.column.createTime': 'createTime',
  'crm_customer_contact.column.updateTime': 'updateTime',
  'crm_customer_contact.column.dataSource': 'dataSource',
  'crm_customer_contact.column.remark': 'remark',
  'crm_customer_contact.column.status': 'status',
  // edit
  'crm_customer_contact.edit.title': 'Edit CrmCustomerContact',
  'crm_customer_contact.add.title': 'Add CrmCustomerContact',
  'crm_customer_contact.edit.success': 'Edit Successful',
  'crm_customer_contact.add.success': 'Add Successful',
  'crm_customer_contact.form.contactName.required': 'contactName cannot be null',
  'crm_customer_contact.form.contactPhone.required': 'contactPhone cannot be null',
  'crm_customer_contact.form.contactType.required': 'contactType cannot be null',
  'crm_customer_contact.form.primaryFlag.required': 'primaryFlag cannot be null',
  'crm_customer_contact.form.enableFlag.required': 'enableFlag cannot be null',
  'crm_customer_contact.form.contactName': 'contactName',
  'crm_customer_contact.form.contactName.placeholder': 'Enter contactName',
  'crm_customer_contact.form.contactPhone': 'contactPhone',
  'crm_customer_contact.form.contactPhone.placeholder': 'Enter contactPhone',
  'crm_customer_contact.form.contactType': 'contactType',
  'crm_customer_contact.form.contactType.placeholder': 'Enter contactType',
  'crm_customer_contact.form.primaryFlag': 'primaryFlag',
  'crm_customer_contact.form.primaryFlag.placeholder': 'Enter primaryFlag',
  'crm_customer_contact.form.enableFlag': 'enableFlag',
  'crm_customer_contact.form.enableFlag.placeholder': 'Enter enableFlag',
}
